var _defs, _sodipodiNamedview, _metadata, _style, _style2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeatgeek(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsdc: "http://purl.org/dc/elements/1.1/",
    xmlnscc: "http://creativecommons.org/ns#",
    xmlnsrdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnssvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: "98.689583mm",
    height: "70.379166mm",
    viewBox: "0 0 98.689584 70.379166",
    id: "svg8",
    inkscapeversion: "0.92.5 (2060ec1f9f, 2020-04-08)",
    sodipodidocname: "seatgeek logo.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 230,78.7 v 0 5.1 c 10.5,3.8 17.7,14.7 17.7,27.4 v 138.6 c 0,38.3 47.6,64 55.6,109.1 -12.2,-33.7 -46.3,-43 -55.6,-75.4 v 14.7 c 0,14.3 4.6,25.3 11,34.5 6.3,8.9 25.7,28.7 30.8,40.9 -2.9,-1.3 -27.4,-13.1 -37.9,-37.9 0,11.8 2.9,31.2 32,53.5 10.9,8.8 28.2,13.5 29.5,44.7 h 5.5 V 94.3 c 11.8,0 19.8,9.3 19.8,21.9 v 167.2 l 45.9,-37.1 c 23.6,-19.8 24.9,-47.6 24.9,-64 v -64 c 0,-27.8 -24.9,-39.6 -49.7,-39.6 z",
    id: "SVGID_1_",
    "inkscapeconnector-curvature": 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.88058,53.4313 0.43475767,53.4313 0.43475767,0.39138181 118.88058,0.39138181 ",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.192508,59.508847 0.47004367,59.508847 0.47004367,0.48826554 80.192508,0.48826554 ",
    id: "path-3"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SeatGeek") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "base",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapepageopacity: 0,
    inkscapepageshadow: 2,
    inkscapezoom: 2.3789062,
    inkscapecx: 192.39835,
    inkscapecy: 157.05949,
    "inkscapedocument-units": "mm",
    "inkscapecurrent-layer": "layer1",
    showgrid: "false",
    "fit-margin-top": 0,
    "fit-margin-left": 0,
    "fit-margin-right": 0,
    "fit-margin-bottom": 0,
    "inkscapewindow-width": 1920,
    "inkscapewindow-height": 1017,
    "inkscapewindow-x": 1912,
    "inkscapewindow-y": 70,
    "inkscapewindow-maximized": 1,
    inkscapepagecheckerboard: "true"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata5"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfresource: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfresource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), /*#__PURE__*/React.createElement("g", {
    inkscapelabel: "Layer 1",
    inkscapegroupmode: "layer",
    id: "layer1",
    transform: "translate(-51.342263,-51.121814)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ff5b49",
      fillOpacity: 1
    },
    id: "g1057",
    transform: "matrix(0.58421093,0,0,0.58649306,51.342263,51.121814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1028",
    d: "m 90.6958,54.884 3.1261,-9.1025 c 5.3579,-0.0201 10.7091,-0.0605 16.0601,-0.1143 l 3.153,9.1631 c 4.659,-0.0202 9.372,0.0672 14.024,0.0403 L 108.504,4.02018 C 106.299,4.10758 97.3378,4.34287 95.2269,4.39665 L 81.2168,43.9193 C 75.4756,43.9126 70.1042,43.879 64.2487,43.8252 V 33.6 l 10.4606,0.121 V 24.5042 L 64.2487,24.3496 v -9.8151 c 11.3748,0.2621 16.6253,0.2084 16.6186,0.2084 L 78.7294,3.79159 c 0,0 -13.6067,-0.22183 -28.4638,-0.84704 V 54.8168 c 2.9445,0.0135 17.6537,0.0605 27.0588,0.0807 v 0.0067 c 1.7143,0 3.3412,0 4.9479,0.0067 0.4571,0 0.8806,0 1.2504,0 2.3462,-0.0269 4.6723,-0.0269 7.1731,-0.0269 z M 106.709,36.4235 c -3.233,0.0471 -6.474,0.0874 -9.714,0.1143 l 4.874,-14.1849 z",
    "inkscapeconnector-curvature": 0,
    style: {
      fill: "#ff5b49",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1030",
    d: "m 132.76,54.8571 c 4.652,-0.0336 9.297,0.0135 13.943,-0.0268 l 0.067,-41.9026 c 5.075,-0.4033 10.144,-0.847 15.206,-1.3512 L 159.819,0 C 146.487,1.59328 133.143,2.75631 119.745,3.49581 L 117.58,14.716 c 5.062,-0.2152 10.124,-0.4773 15.18,-0.7866 z",
    "inkscapeconnector-curvature": 0,
    style: {
      fill: "#ff5b49",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1032",
    d: "m 23.1933,15.2403 c 0,-6.31257 13.4924,-4.6117 19.7176,-0.9478 L 43.4891,1.82186 C 42.0168,1.36472 36.0605,0.00674438 28.9546,0.00674438 18.9042,0.00674438 10.1311,5.94959 10.1311,15.395 c 0,16.8403 22.9849,18.0033 22.9849,24.7596 0,8.8874 -15.2404,3.9463 -22.9849,-3.3882 v 14.2051 c 0,0 5.7008,5.2974 17.0286,5.2974 12.484,0 18.8235,-8.1344 18.8235,-16.9008 C 45.9899,22.2925 23.1933,22.2185 23.1933,15.2403 Z",
    "inkscapeconnector-curvature": 0,
    style: {
      fill: "#ff5b49",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1034",
    d: "M 168.928,120 150.514,88.6386 166.803,63.516 h -15.717 l -14.273,22.3865 c 0.054,-7.4487 -0.053,-14.9042 0,-22.3597 -4.705,-0.0134 -9.243,-0.0201 -13.956,-0.0268 0,13.6739 0,38.608 0,52.282 0,0 9.217,0.565 13.956,0.935 0,-8.067 0,-16.101 0,-24.1616 l 13.775,25.3106 c 6.878,0.706 13.123,1.432 18.34,2.118 z",
    "inkscapeconnector-curvature": 0,
    style: {
      fill: "#ff5b49",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1036",
    d: "m 64.2757,93.5462 c 3.4756,-0.0538 10.4268,-0.1277 10.4268,-0.1277 v -9.3109 c 0,0 -6.9512,0.0537 -10.4268,0.0874 0,-3.2807 0,-6.5681 0,-9.8488 9.7479,0.0067 16.5983,0.0605 16.5983,0.0605 L 78.716,63.5966 H 50.2924 v 51.8994 c 6.5479,-0.424 24.558,-0.834 30.6757,-0.854 0.7193,-3.664 1.4386,-7.334 2.158,-10.992 -6.2857,0 -12.5714,0.074 -18.8504,0.209 0,-3.469 0,-6.8439 0,-10.3128 z",
    "inkscapeconnector-curvature": 0,
    style: {
      fill: "#ff5b49",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1038",
    d: "m 100.605,93.4387 c 3.234,0.047 6.474,0.1008 9.708,0.1748 0,-3.0992 0,-6.1984 0,-9.2975 -3.234,-0.0538 -6.468,-0.0874 -9.708,-0.121 0,-3.2942 0,-6.4807 0,-9.7748 l 16.686,0.1075 -2.151,-10.9176 c 0,0 -19.0122,-0.0135 -28.5181,-0.0135 v 51.0524 c 9.6806,0.006 20.2351,0.316 30.6151,0.847 l 2.252,-11.072 c -5.472,-0.195 -13.902,-0.471 -18.877,-0.579 -0.007,-3.475 -0.007,-6.9442 -0.007,-10.4063 z",
    "inkscapeconnector-curvature": 0,
    style: {
      fill: "#ff5b49",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1040",
    d: "m 23.3076,94.7429 8.484,-0.4168 0.0068,10.8099 c -12.7463,1.156 -17.99,-3.072 -17.99,-15.6839 0,-11.7042 9.4723,-14.6218 18.1984,-14.6218 7.6907,0 11.7713,0.8537 11.7713,0.8537 L 41.4723,63.5563 C 39.442,63.4555 35.8454,63.3412 29.7412,63.3412 15.637,63.3412 0,70.0908 0,91.4487 c 0,17.9763 12.2891,27.1193 27.879,25.6543 10.9782,-1.029 15.9126,-1.251 15.9126,-1.251 V 84.5647 l -18.3328,0.4101 z",
    "inkscapeconnector-curvature": 0,
    style: {
      fill: "#ff5b49",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#255000",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "#006bb6",
      strokeWidth: 0.00394559,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 89.736522,83.223311 -8.986443,-0.05763 V 68.060103 52.954534 l 3.516436,0.112607 c 1.934037,0.06193 5.644518,0.165341 8.245513,0.229782 4.1082,0.101789 4.739815,0.153571 4.810865,0.394447 0.07459,0.252866 1.139592,5.75362 1.139592,5.886008 0,0.03132 -2.189891,0.05695 -4.866426,0.05695 h -4.86643 l 0.04761,2.920015 0.04761,2.92002 3.082304,0.04761 3.082309,0.04761 v 2.610921 2.61092 h -3.125721 -3.125717 v 3.053388 3.053414 l 5.078539,-0.04633 5.078546,-0.04611 4.057711,-11.505742 c 2.23174,-6.32816 4.06843,-11.514459 4.08155,-11.525121 0.013,-0.01064 1.74298,-0.06615 3.84416,-0.123314 l 3.82032,-0.103917 5.28472,14.592645 c 2.9066,8.025963 5.31786,14.690704 5.35835,14.810559 0.0575,0.17024 -0.80109,0.217898 -3.91749,0.217898 h -3.99113 l -0.91244,-2.618659 c -0.50184,-1.440324 -0.96081,-2.648296 -1.01992,-2.684383 -0.0591,-0.03613 -2.2091,-0.01552 -4.77776,0.04744 l -4.6703,0.11305 -0.86753,2.571356 -0.86754,2.571355 h -1.51225 c -0.83174,0 -2.09058,0.02527 -2.79742,0.05586 -0.706842,0.03081 -5.329067,0.03015 -10.271609,-0.0018 z M 113.70128,72.316923 c -0.0438,-0.119855 -0.69025,-2.008899 -1.43651,-4.197873 -0.81404,-2.387742 -1.40837,-3.887193 -1.48561,-3.748081 -0.15163,0.273075 -2.76587,7.880899 -2.76587,8.049093 0,0.06313 1.29772,0.114779 2.88383,0.114779 2.23377,0 2.86586,-0.04914 2.80416,-0.21792 z",
    id: "path1059",
    "inkscapeconnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#255000",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "#006bb6",
      strokeWidth: 0.00394559,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 64.774187,83.92912 c -2.17213,-0.275975 -4.929678,-1.253946 -6.637041,-2.353834 l -0.829952,-0.53466 v -4.071574 -4.071584 l 1.123853,0.853964 c 2.476062,1.881436 4.957872,3.062188 7.533122,3.583925 2.998014,0.607388 4.714153,-0.319067 4.714153,-2.544955 0,-0.893051 -0.03486,-0.961888 -0.916788,-1.80988 -0.631204,-0.606915 -1.69289,-1.286046 -3.408262,-2.180165 -6.139708,-3.200253 -8.357001,-5.529304 -8.906737,-9.355672 -0.641818,-4.467277 1.916467,-8.06675 6.893527,-9.699101 2.130254,-0.698666 7.832598,-0.569284 11.406079,0.258796 l 0.836317,0.193803 -5.82e-4,1.146782 c -3.52e-4,0.630726 -0.05083,2.247746 -0.112125,3.593372 l -0.111506,2.446592 -0.811228,-0.389761 c -0.446115,-0.214373 -1.509191,-0.601443 -2.362334,-0.860179 -1.33398,-0.404558 -1.879408,-0.472866 -3.895458,-0.487869 -2.11384,-0.01574 -2.41571,0.02084 -3.070829,0.372465 -0.836384,0.448848 -1.225673,0.936512 -1.371792,1.718442 -0.244042,1.305927 0.871651,2.331292 4.507752,4.142823 1.458773,0.72677 3.23257,1.70369 3.941771,2.170939 2.559166,1.686079 4.09457,3.720518 4.594159,6.087351 1.096387,5.194199 -1.933209,10.07479 -7.125027,11.478228 -1.026022,0.277349 -4.740462,0.470642 -5.99096,0.311752 z",
    id: "path1061",
    "inkscapeconnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#ff5b11",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "#006bb6",
      strokeWidth: 0.00394559,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 64.774187,83.92912 c -2.17213,-0.275975 -4.929678,-1.253946 -6.637041,-2.353834 l -0.829952,-0.53466 v -4.071574 -4.071584 l 1.123853,0.853964 c 2.476062,1.881436 4.957872,3.062188 7.533122,3.583925 2.998014,0.607388 4.714153,-0.319067 4.714153,-2.544955 0,-0.893051 -0.03486,-0.961888 -0.916788,-1.80988 -0.631204,-0.606915 -1.69289,-1.286046 -3.408262,-2.180165 -6.139708,-3.200253 -8.357001,-5.529304 -8.906737,-9.355672 -0.641818,-4.467277 1.916467,-8.06675 6.893527,-9.699101 2.130254,-0.698666 7.832598,-0.569284 11.406079,0.258796 l 0.836317,0.193803 -5.82e-4,1.146782 c -3.52e-4,0.630726 -0.05083,2.247746 -0.112125,3.593372 l -0.111506,2.446592 -0.811228,-0.389761 c -0.446115,-0.214373 -1.509191,-0.601443 -2.362334,-0.860179 -1.33398,-0.404558 -1.879408,-0.472866 -3.895458,-0.487869 -2.11384,-0.01574 -2.41571,0.02084 -3.070829,0.372465 -0.836384,0.448848 -1.225673,0.936512 -1.371792,1.718442 -0.244042,1.305927 0.871651,2.331292 4.507752,4.142823 1.458773,0.72677 3.23257,1.70369 3.941771,2.170939 2.559166,1.686079 4.09457,3.720518 4.594159,6.087351 1.096387,5.194199 -1.933209,10.07479 -7.125027,11.478228 -1.026022,0.277349 -4.740462,0.470642 -5.99096,0.311752 z",
    id: "path1063",
    "inkscapeconnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#ff5b11",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "#006bb6",
      strokeWidth: 0.00394559,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 64.774187,83.92912 c -2.17213,-0.275975 -4.929678,-1.253946 -6.637041,-2.353834 l -0.829952,-0.53466 v -4.071574 -4.071584 l 1.123853,0.853964 c 2.476062,1.881436 4.957872,3.062188 7.533122,3.583925 2.998014,0.607388 4.714153,-0.319067 4.714153,-2.544955 0,-0.893051 -0.03486,-0.961888 -0.916788,-1.80988 -0.631204,-0.606915 -1.69289,-1.286046 -3.408262,-2.180165 -6.139708,-3.200253 -8.357001,-5.529304 -8.906737,-9.355672 -0.641818,-4.467277 1.916467,-8.06675 6.893527,-9.699101 2.130254,-0.698666 7.832598,-0.569284 11.406079,0.258796 l 0.836317,0.193803 -5.82e-4,1.146782 c -3.52e-4,0.630726 -0.05083,2.247746 -0.112125,3.593372 l -0.111506,2.446592 -0.811228,-0.389761 c -0.446115,-0.214373 -1.509191,-0.601443 -2.362334,-0.860179 -1.33398,-0.404558 -1.879408,-0.472866 -3.895458,-0.487869 -2.11384,-0.01574 -2.41571,0.02084 -3.070829,0.372465 -0.836384,0.448848 -1.225673,0.936512 -1.371792,1.718442 -0.244042,1.305927 0.871651,2.331292 4.507752,4.142823 1.458773,0.72677 3.23257,1.70369 3.941771,2.170939 2.559166,1.686079 4.09457,3.720518 4.594159,6.087351 1.096387,5.194199 -1.933209,10.07479 -7.125027,11.478228 -1.026022,0.277349 -4.740462,0.470642 -5.99096,0.311752 z",
    id: "path1065",
    "inkscapeconnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#ff5b11",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "#ff5b11",
      strokeWidth: 0.00394559,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0
    },
    d: "m 64.774187,83.92912 c -2.17213,-0.275975 -4.929678,-1.253946 -6.637041,-2.353834 l -0.829952,-0.53466 v -4.071574 -4.071584 l 1.123853,0.853964 c 2.476062,1.881436 4.957872,3.062188 7.533122,3.583925 2.998014,0.607388 4.714153,-0.319067 4.714153,-2.544955 0,-0.893051 -0.03486,-0.961888 -0.916788,-1.80988 -0.631204,-0.606915 -1.69289,-1.286046 -3.408262,-2.180165 -6.139708,-3.200253 -8.357001,-5.529304 -8.906737,-9.355672 -0.641818,-4.467277 1.916467,-8.06675 6.893527,-9.699101 2.130254,-0.698666 7.832598,-0.569284 11.406079,0.258796 l 0.836317,0.193803 -5.82e-4,1.146782 c -3.52e-4,0.630726 -0.05083,2.247746 -0.112125,3.593372 l -0.111506,2.446592 -0.811228,-0.389761 c -0.446115,-0.214373 -1.509191,-0.601443 -2.362334,-0.860179 -1.33398,-0.404558 -1.879408,-0.472866 -3.895458,-0.487869 -2.11384,-0.01574 -2.41571,0.02084 -3.070829,0.372465 -0.836384,0.448848 -1.225673,0.936512 -1.371792,1.718442 -0.244042,1.305927 0.871651,2.331292 4.507752,4.142823 1.458773,0.72677 3.23257,1.70369 3.941771,2.170939 2.559166,1.686079 4.09457,3.720518 4.594159,6.087351 1.096387,5.194199 -1.933209,10.07479 -7.125027,11.478228 -1.026022,0.277349 -4.740462,0.470642 -5.99096,0.311752 z",
    id: "path1067",
    "inkscapeconnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#ff5b11",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "#ff5b11",
      strokeWidth: 0.00394559,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0
    },
    d: "m 64.774187,83.92912 c -2.17213,-0.275975 -4.929678,-1.253946 -6.637041,-2.353834 l -0.829952,-0.53466 v -4.071574 -4.071584 l 1.123853,0.853964 c 2.476062,1.881436 4.957872,3.062188 7.533122,3.583925 2.998014,0.607388 4.714153,-0.319067 4.714153,-2.544955 0,-0.893051 -0.03486,-0.961888 -0.916788,-1.80988 -0.631204,-0.606915 -1.69289,-1.286046 -3.408262,-2.180165 -6.139708,-3.200253 -8.357001,-5.529304 -8.906737,-9.355672 -0.641818,-4.467277 1.916467,-8.06675 6.893527,-9.699101 2.130254,-0.698666 7.832598,-0.569284 11.406079,0.258796 l 0.836317,0.193803 -5.82e-4,1.146782 c -3.52e-4,0.630726 -0.05083,2.247746 -0.112125,3.593372 l -0.111506,2.446592 -0.811228,-0.389761 c -0.446115,-0.214373 -1.509191,-0.601443 -2.362334,-0.860179 -1.33398,-0.404558 -1.879408,-0.472866 -3.895458,-0.487869 -2.11384,-0.01574 -2.41571,0.02084 -3.070829,0.372465 -0.836384,0.448848 -1.225673,0.936512 -1.371792,1.718442 -0.244042,1.305927 0.871651,2.331292 4.507752,4.142823 1.458773,0.72677 3.23257,1.70369 3.941771,2.170939 2.559166,1.686079 4.09457,3.720518 4.594159,6.087351 1.096387,5.194199 -1.933209,10.07479 -7.125027,11.478228 -1.026022,0.277349 -4.740462,0.470642 -5.99096,0.311752 z",
    id: "path1069",
    "inkscapeconnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#ff5b11",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "#ff5b11",
      strokeWidth: 0.00394559,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0
    },
    d: "m 64.774187,83.92912 c -2.17213,-0.275975 -4.929678,-1.253946 -6.637041,-2.353834 l -0.829952,-0.53466 v -4.071574 -4.071584 l 1.123853,0.853964 c 2.476062,1.881436 4.957872,3.062188 7.533122,3.583925 2.998014,0.607388 4.714153,-0.319067 4.714153,-2.544955 0,-0.893051 -0.03486,-0.961888 -0.916788,-1.80988 -0.631204,-0.606915 -1.69289,-1.286046 -3.408262,-2.180165 -6.139708,-3.200253 -8.357001,-5.529304 -8.906737,-9.355672 -0.641818,-4.467277 1.916467,-8.06675 6.893527,-9.699101 2.130254,-0.698666 7.832598,-0.569284 11.406079,0.258796 l 0.836317,0.193803 -5.82e-4,1.146782 c -3.52e-4,0.630726 -0.05083,2.247746 -0.112125,3.593372 l -0.111506,2.446592 -0.811228,-0.389761 c -0.446115,-0.214373 -1.509191,-0.601443 -2.362334,-0.860179 -1.33398,-0.404558 -1.879408,-0.472866 -3.895458,-0.487869 -2.11384,-0.01574 -2.41571,0.02084 -3.070829,0.372465 -0.836384,0.448848 -1.225673,0.936512 -1.371792,1.718442 -0.244042,1.305927 0.871651,2.331292 4.507752,4.142823 1.458773,0.72677 3.23257,1.70369 3.941771,2.170939 2.559166,1.686079 4.09457,3.720518 4.594159,6.087351 1.096387,5.194199 -1.933209,10.07479 -7.125027,11.478228 -1.026022,0.277349 -4.740462,0.470642 -5.99096,0.311752 z",
    id: "path1071",
    "inkscapeconnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#ff5b11",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "#ff5b11",
      strokeWidth: 0.00394559,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0
    },
    d: "m 64.774187,83.92912 c -2.17213,-0.275975 -4.929678,-1.253946 -6.637041,-2.353834 l -0.829952,-0.53466 v -4.071574 -4.071584 l 1.123853,0.853964 c 2.476062,1.881436 4.957872,3.062188 7.533122,3.583925 2.998014,0.607388 4.714153,-0.319067 4.714153,-2.544955 0,-0.893051 -0.03486,-0.961888 -0.916788,-1.80988 -0.631204,-0.606915 -1.69289,-1.286046 -3.408262,-2.180165 -6.139708,-3.200253 -8.357001,-5.529304 -8.906737,-9.355672 -0.641818,-4.467277 1.916467,-8.06675 6.893527,-9.699101 2.130254,-0.698666 7.832598,-0.569284 11.406079,0.258796 l 0.836317,0.193803 -5.82e-4,1.146782 c -3.52e-4,0.630726 -0.05083,2.247746 -0.112125,3.593372 l -0.111506,2.446592 -0.811228,-0.389761 c -0.446115,-0.214373 -1.509191,-0.601443 -2.362334,-0.860179 -1.33398,-0.404558 -1.879408,-0.472866 -3.895458,-0.487869 -2.11384,-0.01574 -2.41571,0.02084 -3.070829,0.372465 -0.836384,0.448848 -1.225673,0.936512 -1.371792,1.718442 -0.244042,1.305927 0.871651,2.331292 4.507752,4.142823 1.458773,0.72677 3.23257,1.70369 3.941771,2.170939 2.559166,1.686079 4.09457,3.720518 4.594159,6.087351 1.096387,5.194199 -1.933209,10.07479 -7.125027,11.478228 -1.026022,0.277349 -4.740462,0.470642 -5.99096,0.311752 z",
    id: "path1073",
    "inkscapeconnector-curvature": 0
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style815",
    type: "text/css"
  }, "\n.st0 {\n  fill: #353a40;\n}\n.st1 {\n  clip-path: url(#SVGID_2_);\n  fill: url(#SVGID_3_);\n}\n  ")), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    id: "style856",
    type: "text/css"
  }, "\n.st0 {\n  fill: #ffffff;\n}\n.st1 {\n  fill: #fcb131;\n}\n.st2 {\n  fill: #4f8636;\n}\n.st3 {\n  fill: #910028;\n}\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatgeek);
export default __webpack_public_path__ + "static/media/seatgeek.45ce19c9a53029809a657647ceac6395.svg";
export { ForwardRef as ReactComponent };